import { apiPost } from './http-client';
import type {
  AuthTokenPair,
  ContextRequiredResponse,
  LoginSurface
} from './auth-contexts';

export type StaffLoginResponse = AuthTokenPair | ContextRequiredResponse;

export type StaffLoginBody = {
  email: string;
  phone: string;
  password: string;
  /** Раздел входа: trainer для приложения тренера, staff для CRM. */
  surface?: LoginSurface;
  /** Студия входа (ссылка студии). */
  org_slug?: string | null;
  /** Студии входа списком (используется сервером там, где поддерживается). */
  org_slugs?: string[];
  captcha_token?: string;
};

/** POST /api/v1/auth/login — вход staff (тренер, админка). */
export function postStaffLogin(body: StaffLoginBody): Promise<StaffLoginResponse> {
  return apiPost<StaffLoginResponse>('/api/v1/auth/login', body);
}

export type AuthLogin2FAResponse = AuthTokenPair & {
  user_id?: number;
};

export type AuthLogin2FAResult = AuthLogin2FAResponse | ContextRequiredResponse;

/** POST /api/v1/auth/login/2fa — второй шаг входа при включённой 2FA. */
export function postAuthLogin2FA(body: {
  temp_token: string;
  code: string;
  captcha_token?: string;
}): Promise<AuthLogin2FAResult> {
  return apiPost<AuthLogin2FAResult>('/api/v1/auth/login/2fa', body);
}
